import React, { useState, useRef, useEffect } from 'react';
import "./champions.css";

const carouselSlides = [
    {id: 1, title: "BNT 2025 Champion", name: "Adrian Neville T. Soquita", school: "Mapua University - Manila", img: "/pics/champions/2025.png", achievements: [], accent:"#ffffff"},
    {id: 2, title: "BNT 2024 Champion", name: "Engr. Mark Laurence P. Velasco", school: "De La Salle University - Manila", img: "/pics/champions/2024.png", achievements: ["2nd Place October 2025 ECE Board Exam"], accent:"#ffffff"},
    {id: 3, title: "BNT 2023 Champion", name: "Engr. Niele Shem G. Banas", school: "Technological University of the Philippines - Visayas", img: "/pics/champions/2023.png", achievements: ["1st Place October 2023 ECE Board Exam", "1st Place October 2024 ECT Board Exam"], accent:"#ffffff"},
];

  const filteredSlides = carouselSlides.filter((slide) =>
    slide.title.toLowerCase()
  );

const championsList = [
    {id: 1, rank:"BNT 2025 Champion", name: "Adrian Neville T. Soquita", school: "Mapua University - Manila", img: "/pics/champions/2025.png"},
    {id: 2, rank:"BNT 2024 Champion", name: "Engr. Mark Laurence P. Velasco", school: "De La Salle University - Manila", img: "/pics/champions/2024.png"},
    {id: 3, rank:"BNT 2023 Champion", name: "Engr. Niele Shem G. Banas", school: "Technological University of the Philippines - Visayas", img: "/pics/champions/2023.png" },
    {id: 4, rank:"BNT 2022 Champion", name: "Engr. Jham Paulo P. Delos Reyes", school: "Far Eastern University Institute of Technology", img: "/pics/champions/2022.png" },
    {id: 5, rank:"BNT 2019 Champion", name: "Engr. Samuel P. Candava", school: "Asia Pacific College", img: "/pics/champions/2019.png"},
    {id: 6, rank:"BNT 2018 Champion", name: "Engr. Arman John Morsiquillo", school: "Bulacan State University", img: "/pics/champions/2018.png"},
    {id: 7, rank:"BNT 2017 Champion", name: "Engr. John Philip C. Maramag", school: "Rizal Technological University", img: "/pics/champions/2017.png"},
    {id: 8, rank:"BNT 2016 Champion", name: "Engr. John Donnie I. Celestre", school: "University of the East - Manila", img: "/pics/champions/2016.png"},
    {id: 9, rank:"BNT 2015 Champion", name: "Engr. John Anthony C. Jose", school: "De La Salle University - Manila", img: "/pics/champions/2015.png"},
    {id: 10, rank:"BNT 2013 Champion", name: "Engr. Anam C. Ramos", school: "Technological Institute of the Philippines - Manila", img: "/pics/champions/2013.png"},
    
];

  const filteredChampions = championsList.filter((champ) =>
    champ.name.toLowerCase()
  );

export default function Champions() {
    const [current, setCurrent] = useState(0);
    const [animating, setAnimating] = useState(false);

    useEffect(() =>{
        const timer = setInterval(() =>{
            goTo((prev) => (prev + 1) % carouselSlides.length);
        }, 3500);
        return () => clearInterval(timer);
    }, []);

    function goTo(indexOrFn) {
        setAnimating(true);
        setTimeout(() => {
            setCurrent(prev => typeof indexOrFn === "function" ? indexOrFn(prev) : indexOrFn);
            setAnimating(false);
        }, 300);
    }

    const slide = carouselSlides[current];

    return (
        <div className="champions-page">
            <section className="champions-header-section">
                <h1 className="title">
                    <span className="green"> BNT </span>
                    <span className="white"> CHAMPIONS </span>
                </h1>
                <div className="divider"></div> {/* -- Same as Mech-Diver sa Schools.css */}
            </section>
            <div className="carousel-wrapper">
                <div className="carousel" style={{ boxShadow: `0 0 40px ${slide.accent}22` }}>
                    <div className="carousel-slide" style={{ background: slide.bg, opacity: animating ? 0 : 1, transform: animating ? "scale(0.97" : "scale(1)" }}>
                        <div className="carousel-overlay" />
                        <div className="carousel-image-wrapper">
                            <img src={slide.img} alt={slide.title} className="carousel-image"/>
                        </div>
                        <div className="carousel-content">
                            <div className="carousel-title"style={{color: slide.accent}}>{slide.title}</div>
                            <div className="carousel-name">{slide.name}</div>
                            <div className="carousel-school">{slide.school}</div>
                            <div className="carousel-achievements">
                                {(slide.achievements || []).map((item, i) => (
                                <div key={i} className="carousel-achievement">{item}</div>
                            ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="carousel-controls">
                   <div className="carousel-dots">
                    {carouselSlides.map((s, i) => (
                       <button key={s.id} onClick={() => goTo(i)} style={{ width: i === current ? 24 : 8, height: 8, borderRadius: 4, border: "none", background: i === current ? slide.accent : "#ffffff30", cursor: "pointer", padding: 0, transition: "all 0.3s ease", }}></button>
                    ))}
                   </div>
                </div>
            </div>
            <div className="grid-wrapper">
                <div className="grid-divider">
                    <div className="grid-divider-line-left"></div>
                    <span className="grid-label">List of Champions</span>
                    <div className="grid-divider-line-right"></div>
                </div>
                <div className="champions-grid">
                    {filteredChampions.map((champ, i) => (
                        <ChampionCard key={champ.id} champ={champ} delay={i * 60}></ChampionCard>
                    ))}
                </div>
            </div>
        </div>
    );
}

function ChampionCard({champ, delay}) {
    const [hovered, setHovered] = useState(false);
    const [visible, setVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer =  new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => setVisible(true), delay);
                    observer.disconnect();
                }
            },
            {threshold: 0.15}
        );
        if (ref.current) observer.observe(ref.current);
        return  () => observer.disconnect();
    }, [delay]);

    return (
        <div ref={ref} className="card"  style={{ opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(28px)", transition: "opacity 0.6s ease, transform 0.6s ease",}}>
            <div className="card-image-wrapper">
                <img src={champ.img || "pics/bnt.png"} alt={champ.name} className="card-image"/>
            </div>
            <div className="card-content">
                <div className="card-rank">{champ.rank}</div>
                <div className="card-name">{champ.name}</div>
                <div className="card-school">{champ.school}</div>
            </div>
        </div>
    )
}